import { signOut as amplifySignOut } from 'aws-amplify/auth'

export async function onboardingSignOut() {
  try {
    await amplifySignOut()
  } catch (error) {
    console.warn('Cognito sign-out failed', error)
  }
}
